export const initialState = {
    formData: {
      name: 'CCH iFirm',
      description: 'CCH iFirm - Products/Services',
      domainUrl: '',
      apiKey: '',
      isFirmIntegrationActive: false,
    },
    showPassword: false,
    canActivate: false,
    canSubmit: false,
    isLoading: false,
    isSubmitted: false,
    apiMessage: '',
    validationErrors: {},
  };
  
  export const actionTypes = {
    SET_FORM_DATA: 'SET_FORM_DATA',
    TOGGLE_PASSWORD: 'TOGGLE_PASSWORD',
    SET_CAN_ACTIVATE: 'SET_CAN_ACTIVATE',
    SET_CAN_SUBMIT: 'SET_CAN_SUBMIT',
    SET_LOADING: 'SET_LOADING',
    SET_API_MESSAGE: 'SET_API_MESSAGE',
    SET_VALIDATION_ERRORS: 'SET_VALIDATION_ERRORS',
  };
  
  export function formReducer(state, action) {
    switch (action.type) {
      case actionTypes.SET_FORM_DATA:
        return { ...state, formData: { ...state.formData, ...action.payload } };
      case actionTypes.TOGGLE_PASSWORD:
        return { ...state, showPassword: !state.showPassword };
      case actionTypes.SET_CAN_ACTIVATE:
        return { ...state, canActivate: action.payload };
      case actionTypes.SET_CAN_SUBMIT:
        return { ...state, canSubmit: action.payload };
      case actionTypes.SET_LOADING:
        return { ...state, isLoading: action.payload };
      case actionTypes.SET_SUBMITTED:
        return { ...state, isSubmitted: action.payload };  
      case actionTypes.SET_API_MESSAGE:
        return { ...state, apiMessage: action.payload };
      case actionTypes.SET_VALIDATION_ERRORS:
        return { ...state, validationErrors: action.payload };  
      default:
        return state;
    }
  }